module.exports = __webpack_public_path__ + "static/img/3_1_2.eaa09c85.jpg";